"use client";
import { useEffect, useState } from "react";
import Link from "next/link";

export default function BlogsPage() {
  const [blogs, setBlogs] = useState<any[]>([]);

  useEffect(() => {
    fetch("/api/blogs")
      .then(res => res.json())
      .then(setBlogs);
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Tous nos blogs</h1>

      {blogs.length === 0 && <p>No blogs found.</p>}

      <ul>
        {blogs.map(blog => (
          <li key={blog.id} className="border-b py-4">
            <Link href={`/blogs/${blog.slug}`}>
              <h2 className="text-xl font-semibold">{blog.title}</h2>
            </Link>
            {blog.image && (
              <img src={blog.image} alt={blog.title} className="w-full rounded mt-2" />
            )}
            <p className="text-gray-600 mt-1">{blog.excerpt}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
